























import { Component, Mixins, Inject } from 'vue-property-decorator';
import TableComponent from '@/components/Table/TableComponent.vue';
import TableMixin from '@/mixins/tableMixins';
import { fetchComplianceTotal } from '@/api/drilldown';
import { View, FetchedData, IExport, FetchedItem } from '@/interfaces';
import { exportMaterialDeclarationTotalMassReport } from '@/api/export';
import User from '@/models/User';
import UIPermissions from '@/models/UIPermissions';
import { ExportType } from '@/models/Export';
import exportData from '@/helpers/exportData';

@Component({
  components: {
    TableComponent,
  },
})
export default class ComplianceTotal extends Mixins(TableMixin) {
  @Inject() user!: User;

  public defaultView: View = {
    name: 'Default',
    fields: [
      'Substance',
      'CAS_Number',
      'Mass',
    ],
    default: false,
    selected: true,
  };

  public notSortable: string[] = [];

  async mounted(): Promise<void> {
    this.getURLParams();
    await this.fetchData();
    this.isLoadingNewRecords = false;
    this.isExportDisabled = false;
    this.emitListener();
  }

  public async fetchData(): Promise<void> {
    this.isExportDisabled = true;
    const declarationData = await fetchComplianceTotal({
      id: this.idDeclaration,
      filters: this.query,
      lowerThreshold: this.itemsRange[0],
      upperThreshold: this.itemsRange[1],
      sortingName: this.sorting.name,
      sortingOrder: this.sorting.order,
    });
    this.data = {
      itemsLength: declarationData.itemsLength,
      items: declarationData.items,
      views: declarationData.views,
    };
    this.isExportDisabled = false;
  }

  get availableExportTypes(): ExportType[] {
    if (this.haveAccessToTotalReportExport) {
      return [ExportType.CSV, ExportType.XSLX, ExportType.REPORT];
    }
    return [ExportType.CSV, ExportType.XSLX];
  }

  get haveAccessToCustomTotalReportExport(): boolean {
    return this.user.permissions.includes(UIPermissions.CUSTOM_TOTAL_REPORT_EXPORT);
  }

  get haveAccessToTotalReportExport(): boolean {
    return this.user.permissions.includes(UIPermissions.ACCESS_TO_EXPORT_TOTAL_REPORT_STD);
  }

  get processedData(): FetchedData {
    const lengthRoot = this.data.items.length;
    return {
      itemsLength: lengthRoot,
      items: this.data.items,
      views: this.data.views,
    };
  }

  get filteredData(): FetchedItem[] {
    // eslint-disable-next-line
    const regexp = /^\d+(?:-\d+){2}$/;
    return this.data.items.filter((e) => {
      if (typeof e.CAS_Number === 'string') {
        return regexp.test(e.CAS_Number) || e.Substance?.toString().includes('MISC');
      }
      return false;
    });
  }

  public async exportComplianceTotalTable(exportDataParams: IExport): Promise<void> {
    this.isExportLoading = true;
    if (exportDataParams.format === ExportType.REPORT) {
      const fileName = `${this.itemName}_Material_Declaration_Total_Mass_Report.xlsx`;
      await exportMaterialDeclarationTotalMassReport(this.id, this.idDeclaration, fileName);
    } else if (this.haveAccessToCustomTotalReportExport) {
      await this.exportTableCustom(exportDataParams);
    } else {
      await this.exportTable(exportDataParams);
    }
    this.isExportLoading = false;
  }

  public async exportTableCustom(exportDataParams: IExport): Promise<void> {
    this.isExportLoading = true;
    const fileName = `${this.partNumber}_${this.$route.meta?.export}_${new Date().getFullYear()}_${new Date().getMonth()}_${new Date().getDate()}`;
    exportData(
      exportDataParams.format,
      this.filteredData,
      fileName,
      this.$route.meta?.export,
      exportDataParams.headers
    );
    this.isExportLoading = false;
  }
}
